import { RecordUtils } from "@rsm-hcd/javascript-core";
import { NotebookPageContentBlock } from "../../constants/notebooks/notebook-page-content-blocks";
import { Block } from "../interfaces/block";
import { Record } from "immutable";

const defaultValues: Block = RecordUtils.auditableDefaultValuesFactory({
    configuration: undefined,
    pageId: 0,
    type: NotebookPageContentBlock.Text,
    sortIndex: 0,
});

export class BlockRecord extends Record(defaultValues) implements Block {
    constructor(params?: Partial<Block>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    with(values: Partial<Block>): BlockRecord {
        return new BlockRecord(Object.assign(this.toJS(), values));
    }
}
